/*
 * Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
 * Distributed under the TruVideo proprietary license.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';

const ChecklistDeleteModal = ({ isOpen, title, message, preview, note, deleting, onCancel, onConfirm }) => (
  <Modal isOpen={isOpen} onClose={deleting ? () => {} : onCancel} title={title}>
    <div className="mb-6 space-y-3">
      <p className="text-base-content/70 text-sm leading-relaxed">{message}</p>
      {preview && (
        <p className="p-3 rounded-xl bg-base-200 text-sm text-base-content/80 whitespace-pre-wrap break-words line-clamp-4">
          {preview}
        </p>
      )}
      {note && <p className="text-xs text-base-content/50">{note}</p>}
    </div>
    <div className="flex gap-3">
      <button
        type="button"
        onClick={onCancel}
        className="flex-1 px-4 py-2.5 border border-base-content/20 text-base-content/70 rounded-xl font-bold text-sm hover:bg-base-200 transition"
        disabled={deleting}
      >
        Cancel
      </button>
      <button
        type="button"
        onClick={onConfirm}
        disabled={deleting}
        className="flex-1 px-4 py-2.5 bg-error text-error-content rounded-xl font-bold text-sm hover:opacity-90 transition disabled:opacity-50"
      >
        {deleting ? 'Deleting...' : 'Delete'}
      </button>
    </div>
  </Modal>
);

ChecklistDeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  preview: PropTypes.string,
  note: PropTypes.string,
  deleting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ChecklistDeleteModal;
